import styled from 'styled-components';

import { BoxShadow, Color, FontWeight, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { MenuPosition } from '../menuPosition/menuPosition.component';

import { DropdownMenuContainerProps, LabelProps, IconContainerProps } from './dropdownMenu.types';
import { getIconMenuColor } from './dropdownMenu.utils';

export const Container: StyledComponent<'div'> = styled.div`
  position: relative;
`;

export const DropdownMenuContainer: StyledComponent<'div', DropdownMenuContainerProps> = styled.div<DropdownMenuContainerProps>`
  box-shadow: ${BoxShadow.BackgroundShadow};
  border-radius: 4px;
  background-color: ${Color.White};
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  transition: 0.5s;
  overflow: hidden;
  padding: ${({ $visible }: DropdownMenuContainerProps): string => $visible ? '11px 0' : '0'};
  max-height: ${({ $visible }: DropdownMenuContainerProps): string => $visible ? '600px' : '0'};
  z-index: ${ZIndex.Min};
`;

export const DropdownMenuPositionWrapper: StyledComponent<'div'> = styled.div``;

export const DropdownMenuPosition: StyledComponent<typeof MenuPosition> = styled(MenuPosition)`
  display: flex;
  align-items: center;
  padding: 9px 20px;
  transition: 0.3s;
  text-align: left;
  width: 100%;

  &:hover {
    background-color: ${Color.Gray100};
  }
`;

export const DropdownMenuPositionLabel: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Medium};
  font-size: 14px;
  line-height: 18px;
  color: ${Color.Gray500};
  margin-left: 12px;
  white-space: nowrap;
`;

export const TriggerMenuButton: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
`;

export const IconContainer: StyledComponent<'div', IconContainerProps> = styled.div<IconContainerProps>`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: 0.3s;
  flex-shrink: 0;
  ${(props: IconContainerProps): string => `background-color: ${getIconMenuColor(props.$active, props.$theme)}`};
`;

export const Label: StyledComponent<'div', LabelProps> = styled.div<LabelProps>`
  font-weight: ${FontWeight.Medium};
  font-size: 14px;
  line-height: 18px;
  color: ${Color.Black};
  padding-right: 8px;
  transition: 0.3s;
  ${(props: LabelProps): string => `color: ${getIconMenuColor(props.$active, props.$theme)}`};
`;
